import { render, staticRenderFns } from "./DotIndicator.component.vue?vue&type=template&id=69f494f3&scoped=true&"
import script from "./DotIndicator.component.vue?vue&type=script&lang=js&"
export * from "./DotIndicator.component.vue?vue&type=script&lang=js&"
import style0 from "./DotIndicator.component.vue?vue&type=style&index=0&id=69f494f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f494f3",
  null
  
)

export default component.exports